import { useEffect, useMemo, useState } from "react";

export type AspectCorrection = { scaleX: number; scaleY: number };

const IDENTITY: AspectCorrection = { scaleX: 1, scaleY: 1 };

function computeCorrection(w: number, h: number): AspectCorrection {
    if (w <= 0 || h <= 0) return IDENTITY;
    return {
        scaleX: Math.sqrt(h / w),
        scaleY: Math.sqrt(w / h)
    };
}

export function useSpiderwebViewportAspect(active: boolean): AspectCorrection {
    const [dims, setDims] = useState<{ w: number; h: number }>(() =>
        typeof window !== "undefined"
            ? { w: window.innerWidth, h: window.innerHeight }
            : { w: 1, h: 1 }
    );

    useEffect(() => {
        if (!active) return;

        const update = () =>
            setDims({ w: window.innerWidth, h: window.innerHeight });

        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, [active]);

    return useMemo(
        () => (active ? computeCorrection(dims.w, dims.h) : IDENTITY),
        [active, dims.w, dims.h]
    );
}
